module.exports = __webpack_public_path__ + "img/header-profile-skin-2.8307c45c.png";